<div
  v-if="view_membership_loading"
  class="customer-profile-loader-wrap marketplace-loader-wrap d-flex align-items-center justify-content-center"
  role="status"
  aria-live="polite"
>
  <div class="marketplace-loader-card">
    <div class="marketplace-loader-orbit">
      <span class="marketplace-loader-ring marketplace-loader-ring-primary"></span>
      <span class="marketplace-loader-ring marketplace-loader-ring-secondary"></span>
      <span class="marketplace-loader-core d-flex align-items-center justify-content-center">
        <i class="bi bi-patch-check-fill"></i>
      </span>
      <span class="marketplace-loader-dot marketplace-loader-dot-one"></span>
      <span class="marketplace-loader-dot marketplace-loader-dot-two"></span>
    </div>
    <p class="marketplace-loader-title mb-1">Loading membership</p>
    <p class="marketplace-loader-copy mb-0">We are preparing your membership options.</p>
    <span class="visually-hidden">Loading membership...</span>
  </div>
</div>

<div v-else class="verification-flow">

    <HomeNavBar/>


    <div class="container py-4">
      <div class="d-none mb-4 step-indicator">
        <div class="row justify-content-center">
          <div class="col-auto" v-for="(step, index) in steps" :key="index">
            <div class="step d-flex flex-column align-items-center" :class="{ active: currentStepIndex === index, completed: currentStepIndex > index }">
              <div class="step-circle" :class="currentStepIndex === index ? 'bg-secondary text-white border-primary' : currentStepIndex > index ? 'bg-primary text-white border-success' : 'bg-light text-secondary border border-2'">{{ index + 1 }}</div>
              <div class="step-label" :class="currentStepIndex === index ? 'text-secondary fw-bold' : currentStepIndex > index ? 'text-primary' : 'text-primary'">{{ step.label }}</div>
            </div>
          </div>
        </div>
      </div>


      <div v-if="currentStepIndex === 0" class="pb-extra">
        <button class="btn btn-light rounded-circle p-2 d-flex align-items-center justify-content-center back-btn "
          @click="go_back"><i class="bi bi-chevron-left fs-5"></i>
        </button>
        <h2 class="text-center text-primary mb-4 fw-bold">
          {{ current_membership ? 'Update Your Membership Plan' : 'Choose Your Membership Plan' }}
        </h2>
        <div v-if="active_membership_plans.length" class="row g-4 mb-3">
  <div class="col-md-4 d-flex align-items-stretch" v-for="(plan, index) in active_membership_plans" :key="plan.id">
    <div
      class="w-100 d-flex flex-column align-items-center"
      :class="is_current_plan(plan) ? 'pt-0' : 'pt-4 pt-md-5'"
    >

      <!-- Current Plan Badge -->
      <span
        v-if="is_current_plan(plan)"
        class="badge d-block w-100 bg-primary text-white fw-bold fs-6 px-4 py-2 border border-dark border-bottom-0 membership-current-plan-badge">
        Current Plan
      </span>

      <!-- Membership Plan Card -->
      <div
        class="membership-card rounded p-4 w-100 d-flex flex-column text-center membership-card-border"
        :class="[
          is_current_plan(plan) ? 'rounded-top-0 border-top-0 current-membership-card' : '',
          'border-2',
          selectedPlan === index
            ? 'border-danger shadow-sm'
            : ''
        ]"
        @click="!is_current_plan(plan) && selectPlan(index)"
      >

        <!-- Plan Name -->
        <h4
          class="fw-bold mb-1 text-secondary">
          {{ plan?.membership_type?.name }}
        </h4>
        <small
          class="text-muted text-xxs membership-card-description"
          :class="{ 'membership-card-description-empty': !plan.description }"
        >
          {{plan?.description}}
        </small>

        <!-- Price -->
        <!-- Billing cycle -->
        <div
          class="fs-4 fw-semibold text-primary mb-1 mt-3"
        >
          {{
            (plan?.membership_pricing || []).length > 0
              ? format_currency(plan?.membership_pricing[0].price)
              : 'N/A'
          }}/<small class="text-muted text-xxs">
          {{ plan?.billing_cycle?.name || '-' }}
          </small>
        </div>

        <!-- Action Button -->
        <div class="mt-auto">
          <button
            v-if="is_current_plan(plan)"
            class="btn btn-secondary px-4 py-2 rounded fw-semibold w-100"
            disabled>
            Current
          </button>
          <button
            v-else
            class="btn px-4 py-2 fw-semibold w-100"
            :class="selectedPlan === index ? 'btn-primary text-white' : 'btn-secondary'"
            @click="nextStep">
            {{
              selectedPlan === index
                ? 'Selected'
                : userHasPaid
                  ? `Switch to ${plan?.membership_type?.name}`
                  : 'Select'
            }}
          </button>
        </div>

        <!-- Perk Features -->
        <ul class="list-unstyled text-start mb-4 flex-grow-1 membership-card-features">
          <li
            v-for="(feature, i) in get_visible_perks(plan)"
            :key="i"
            class="d-flex align-items-start gap-2 py-2 border-bottom small">
            <i class="bi bi-check-circle-fill text-primary mt-1"></i>
            {{ feature?.perk?.name }}
          </li>
        </ul>
        <div v-if="(plan?.membership_perks || []).length > 5" class="mt-2 d-flex justify-content-end">
          <button
            type="button"
            class="btn btn-link btn-sm p-0 text-primary text-decoration-none fw-semibold"
            @click.stop="toggle_perks(plan.id)"
          >
            <span>{{ expandedPerks[plan.id] ? 'See less benefits' : 'See more benefits' }}</span>
            <i
              class="bi ms-1"
              :class="expandedPerks[plan.id] ? 'bi-caret-up-fill' : 'bi-caret-down-fill'"
            ></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
        <div v-else class="py-5">
          <div class="d-flex flex-column align-items-center justify-content-center text-center text-muted py-4">
            <p class="mb-0">No memberships found</p>
          </div>
        </div>

      </div>


      <div v-if="currentStepIndex === 1" class="step-content bg-white p-4 p-md-5 rounded membership-card-border">
         <button class="btn btn-light rounded-circle p-2 d-flex align-items-center justify-content-center back-btn "
          @click="prevStep"><i class="bi bi-chevron-left fs-5"></i>
        </button>
  <!-- Header -->
  <h2 class="text-center text-primary fw-bold mb-4">Payment Information</h2>

  <!-- Order Summary Card -->
  <div v-if="selected_membership_plan" class="bg-light p-4 rounded border mb-4">
    <h4 class="fw-semibold position-relative pb-2 mb-4 text-secondary">
      Order Summary
      <span class="position-absolute bottom-0 start-0 bg-primary"></span>
    </h4>

    <div class="d-flex justify-content-between align-items-center py-3 border-bottom small">
      <span class="text-muted">
        {{ selected_membership_plan.membership_type?.name }} Plan
        <small class="text-primary">({{ selected_membership_plan.billing_cycle?.name || '-' }})</small>
      </span>
      <span class="fw-medium">
        {{ format_currency(selected_membership_plan.membership_pricing[0].price) }}
      </span>
    </div>

    <div class="d-flex justify-content-between align-items-center pt-4 mt-2 fw-bold fs-5 text-secondary">
      <span>Total</span>
      <span>
        {{ format_currency(selected_membership_plan.membership_pricing[0].price) }}
      </span>
    </div>
  </div>

  <!-- Navigation Buttons -->
  <div class="d-flex justify-content-end align-items-center mt-4">
    <button
      class="btn btn-primary rounded text-xxs py-1 px-3"
      @click="completePayment"
    >
      Subscribe
    </button>
  </div>

  <!-- Hidden Payment Form -->
  <form id="payment_form" :action="payfast" method="POST" class="d-none">
    <input type="submit" value="Submit" />
  </form>

  <input type="hidden" id="input_clone" class="d-none" />
</div>

    <div
      class="modal fade"
      id="manage_subscription_modal"
      tabindex="-1"
      aria-labelledby="manageSubscriptionModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content rounded-4 border-0 shadow">
          <div class="modal-header border-0 pb-0">
            <h5 class="modal-title text-primary fw-bold" id="manageSubscriptionModalLabel">Manage Subscription</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body pt-2" v-if="current_membership">
            <div class="mb-3">
              <div class="small text-muted mb-1">Plan</div>
              <div class="fw-bold text-dark">{{ current_membership.membership_type?.name || current_membership.name }}</div>
            </div>
            <div class="mb-3">
              <div class="small text-muted mb-1">Status</div>
              <div class="fw-semibold" :class="current_membership.is_active ? 'text-success' : 'text-danger'">
                {{ current_membership.is_active ? 'Active' : 'Inactive' }}
              </div>
            </div>
            <div class="mb-3">
              <div class="small text-muted mb-1">Billing cycle</div>
              <div class="fw-medium text-dark">{{ current_membership.billing_cycle?.name || '-' }}</div>
            </div>
            <div>
              <div class="small text-muted mb-1">Price</div>
              <div class="fw-medium text-dark">
                {{ format_currency(current_membership.membership_pricing?.[0]?.price) }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    </div>
  </div>
